import * as React from "react";
import ViewListAsset from "@warda/library-ui/layout/ViewListAsset";
import { useAppMediaTypeCtx } from "@warda/library-ui/contexts/AppMediaTypeContext";
import ViewListAssetChildren from "./ViewListAssetChildren";
import { getAssetPropsMedia } from "../utils";
import { useContextDispatchViewport } from "../../SharePage";
import getSPPreviewSrcUrl from "../../../../utils/getSPPreviewSrcUrl";
import getSPVideoPreviewUrls from "../../../../utils/getSPVideoPreviewUrls";
const previewWidth = 40;
const previewHeight = 40;
const ViewListAssetMedia = ({ id, color, size, data, columns, columnsShow, selected, selectedIds, contextmenuOriginAnchor, contextmenuOriginTransf, contextmenuPosizionZone, onContextMenu, }) => {
    const dispatchViewport = useContextDispatchViewport();
    const appMediaTypeCtx = useAppMediaTypeCtx();
    const { fileId, mimeType, sizeInBytes, created, renditions } = data;
    const props = getAssetPropsMedia({
        dispatchViewport,
        color,
        id,
        data,
        selected,
        selectedIds,
        onContextMenu,
        contextmenuOriginAnchor,
        contextmenuOriginTransf,
        contextmenuPosizionZone,
        mimeTypeToMediaKind: appMediaTypeCtx.mimeTypeToMediaKind,
    });
    return (React.createElement(ViewListAsset, { ...props, style: { paddingRight: 15 }, width: size[0], height: size[1], preview: {
            previewWidth,
            previewHeight,
            srcUrl: getSPPreviewSrcUrl({
                fileId,
                size: 0,
                mimeType,
                mimeTypeToMediaKind: appMediaTypeCtx.mimeTypeToMediaKind,
            }),
            ...getSPVideoPreviewUrls({
                fileId,
                renditions,
                mimeType,
                mimeTypeToMediaKind: appMediaTypeCtx.mimeTypeToMediaKind,
            }),
            mimeType,
            placeholderIcon: props.icon,
            placeholderIconStyle: { fontSize: 18 },
        }, children: React.createElement(ViewListAssetChildren, { columns: columns, columnsShow: columnsShow, mimeType: mimeType, sizeInBytes: sizeInBytes, created: created }) }));
};
export default ViewListAssetMedia;
